export {
  AvatarGroup,
  renderAvatarGroup,
  useAvatarGroup,
  useAvatarGroupContextValues,
  AvatarGroupItem,
  renderAvatarGroupItem,
  useAvatarGroupItem,
  AvatarGroupPopover,
  renderAvatarGroupPopover,
  useAvatarGroupPopover,
  useAvatarGroupPopoverContextValues,
} from './components/AvatarGroup/index';
export type {
  AvatarGroupSlots,
  AvatarGroupProps,
  AvatarGroupState,
  AvatarGroupContextValue,
  AvatarGroupContextValues,
  AvatarGroupItemSlots,
  AvatarGroupItemProps,
  AvatarGroupItemState,
  AvatarGroupPopoverSlots,
  AvatarGroupPopoverProps,
  AvatarGroupPopoverState,
  AvatarGroupPopoverPopoverProps,
} from './components/AvatarGroup/index';

export { partitionAvatarGroupItems } from '@fluentui/react-avatar';
export type { PartitionAvatarGroupItems, PartitionAvatarGroupItemsOptions } from '@fluentui/react-avatar';
